<template>
  <div id="userProfile">
  <div :class="['gradient-card', 'card', 'user-profile-card', {'plain-card': $utils.isPageForLicenses()}]">
    <div class="header">
      <div class="icon"></div>
      <h4 class="title">{{$t('label.userProfile')}}</h4>
     </div>

    <div class="body contact">
      <div class="user-profile-form-wrapper hide-scrollbar">
        <el-form v-if="userProfileForm" :model="userProfileForm" :rules="userProfileRules" ref="userProfileForm" class="user-profile-form">
          <div class="form-col col-1">
            <div class="column-title">{{$t('label.credentials')}}</div>

            <!-- First Name -->
            <el-form-item class="firstName f-item" prop="firstName">
              <el-input v-model="userProfileForm.firstName"
                :placeholder="`* ${$t('label.firstName')}`"
                @focus="fieldEventCommonStyle('focus', 'input-firstName')"
                @blur="fieldEventCommonStyle('blur', 'input-firstName')"
                class="cstm-input-white input-firstName">
              </el-input>

              <div v-if="error.length > 0" class="animated shake backend-error-msg target-el-form-item_firstName">{{error}}</div>
            </el-form-item>

            <!-- Last Name -->
            <el-form-item class="lastName f-item" prop="lastName">
              <el-input v-model="userProfileForm.lastName"
                :placeholder="`* ${$t('label.lastName')}`"
                @focus="fieldEventCommonStyle('focus', 'input-lastName')"
                @blur="fieldEventCommonStyle('blur', 'input-lastName')"
                class="cstm-input-white input-lastName">
              </el-input>

              <div v-if="error.length > 0" class="animated shake backend-error-msg target-el-form-item_lastName">{{error}}</div>
            </el-form-item>

            <!-- Email -->
            <el-form-item class="email f-item" prop="email">
              <el-input v-model="userProfileForm.email"
                :placeholder="`* ${$t('label.email')}`"
                :disabled="!isChangeEmailPasswordAllowed"
                @focus="fieldEventCommonStyle('focus', 'input-email')"
                @blur="fieldEventCommonStyle('blur', 'input-email')"
                class="cstm-input-white input-email">
              </el-input>

              <div v-if="error.length > 0" class="animated shake backend-error-msg target-el-form-item_email">{{error}}</div>

              <el-popover
                v-if="!isChangeEmailPasswordAllowed"
                popper-class="custom-popover-popper !p-4 !text-xs"
                placement="right"
                width="255"
                trigger="hover">
                <template #reference>
                  <el-icon class="!text-lg !text-white hover:!text-gray-400 absolute right-0">
                    <QuestionFilled />
                  </el-icon>
                </template>
                <template #default>
                  <p v-html="$t('texts.externalSignInMessage', { email: `<b>${$t('label.email')}</b>`, password: `<b>${$t('label.password')}</b>` })"></p>
                </template>
              </el-popover>
            </el-form-item>
          </div>

          <div v-if="isChangeEmailPasswordAllowed" class="form-col col-2">
            <div class="column-title">{{$t('label.password')}}</div>

            <div class="password-item f-item">
              <div id="passwordInfo">
                <div class="password-content">
                  <div class="password-val">{{'••••••••••••'}}</div>
                  <div class="password-edit-icon" @click="showChangePasswordModal = true"></div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>

      <el-button @click="handleUserProfileFormSubmit" class="cstm-btn-white user-profile-form-submit-btn">{{$t('label.saveChanges')}}</el-button>
      <el-button @click="handleDeleteUser" class="cstm-btn-white user-profile-delete-user-btn">{{$t('label.deleteUser')}}</el-button>
    </div>
  </div>

  <!--- Change Password Dialog -->
  <div v-if="showChangePasswordModal" id="changePasswordModal">
    <div :class="['gradient-card', 'card', 'clear-background', {'plain-card': ($utils.isPageForLicenses())}]">
        <div class="header">
          <div class="close-icon" @click="toggleChangePasswordModal"></div>
          <h4 class="title">{{$t('label.password')}}</h4>
        </div>
        <div class="body">
          <reset-password
            v-if="!showPasswordChangeSuccess"
            class="h-[calc(100%-28px)]!"
            is-auto-verify-email
            :is-page-mini="isPageMini"
            :email="userProfileForm.email"
            @success-submit="showPasswordChangeSuccess = true"
            @failed-reset="toggleChangePasswordModal"
          >
          </reset-password>
          <div
            v-else
            class="max-[1919px]:py-16 min-[1920px]:py-20 max-[1919px]:text-xs min-[1920px]:text-md text-white text-center">
            <p>{{$t('label.passwordHasBeenChanged')}}</p>
          </div>
        </div>
      </div>
  </div>
</div>
</template>

<script src="./user-profile.js"></script>
<style lang="scss" src="./user-profile.scss"></style>
